import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { Dispatch } from 'redux';

import { User } from '../../types/entity.types';
import { RootState } from '../../types/state/root.types';
import { SystemState } from '../../types/state/system.types';

import { retrieveFromLocalStorage } from '../../utils/util';
import { ERROR } from '../../utils/constants';

import { requestUpdateSystemUser, requestViewSystemUser } from '../../api/system-user/system-user.actions';
import { addSystemNotice } from '../../slices/system/system.slice';

import Profile from '../../components/common/profile/Profile';

type Props = {
  show: boolean;
};

const ProfileContainer = ({ show }: Props): ReactElement => {
  const { user } = useSelector(({ system }: RootState): SystemState => system);

  const dispatch: Dispatch = useDispatch();

  const navigate: NavigateFunction = useNavigate();

  useEffect((): void => {
    if (!user) {
      const externalReference: string = retrieveFromLocalStorage('user');
      if (externalReference) {
        // @ts-expect-error TODO: Fix after adding types to system user actions
        dispatch(requestViewSystemUser({ externalReference }));
      }
    }
  }, [dispatch, user]);

  const signOut = (): void => {
    localStorage.clear();
    navigate('/');
  };

  const updateSystemUser = (user: User): void => {
    // @ts-expect-error TODO: Fix after adding types to system user actions
    dispatch(requestUpdateSystemUser({ input: user }));
  };

  const showErrorToaster = (message: string): void => {
    dispatch(addSystemNotice({ type: ERROR, message }));
  };

  return (
    <Profile
      show={show}
      user={user}
      signOut={signOut}
      updateSystemUser={updateSystemUser}
      showErrorToaster={showErrorToaster}
    />
  );
};

export default ProfileContainer;
